











import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Card from '@/stories/utils/card.vue';
import UiCopyTextarea from '@/components/ui/ui-copy-textarea.vue';

@Component({
  components: {
    UiCopyTextarea,
    Card,
  }
})
export default class StorybookCopyInput extends Vue {
}
